
const React = require('react')
const WrapRoot = require("./src/components/WrapRoot").default
const WrapPage = require("./src/components/WrapPage").default

exports.wrapRootElement = ({ element }) =>
	<WrapRoot>{element}</WrapRoot>

exports.wrapPageElement = ({ element, props }) =>
	<WrapPage {...props}>{element}</WrapPage>